import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {ReactQueryDevtools} from 'react-query/devtools'
import { Routes } from "./routes";

const queryClient = new QueryClient()
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Routes />
      <ToastContainer />
      <ReactQueryDevtools initialIsOpen={false} position='bottom-left' />
  </QueryClientProvider >
  );
}

export default App;
